import { CommonDateModeEnum, DatePreset, DefaultDateModeEnum } from './date-component.models';

export const defaultDatePreset = {
    mode: DefaultDateModeEnum.previousBusinessDay,
    value: 'B-1'
};
export const defaultModePresets: DatePreset[] = [
    {
        mode: DefaultDateModeEnum.today,
        label: 'Today (D)',
        value: 'D'
    },
    {
        mode: DefaultDateModeEnum.previousBusinessDay,
        label: 'Previous business day (B-1)',
        value: 'B-1'
    },
    {
        mode: DefaultDateModeEnum.previousDay,
        label: 'Previous day (D-1)',
        value: 'D-1'
    },
    {
        mode: CommonDateModeEnum.calendarDate,
        label: 'Fixed date',
        value: null
    },
    {
        mode: CommonDateModeEnum.custom,
        label: 'Advanced',
        value: null
    }
];
